import { render, staticRenderFns } from "./com-menu.vue?vue&type=template&id=54b68768&scoped=true&"
import script from "./com-menu.vue?vue&type=script&lang=js&"
export * from "./com-menu.vue?vue&type=script&lang=js&"
import style0 from "./com-menu.vue?vue&type=style&index=0&id=54b68768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b68768",
  null
  
)

export default component.exports